import { render, staticRenderFns } from "./FileElement.vue?vue&type=template&id=6834498a&scoped=true&"
import script from "./FileElement.vue?vue&type=script&lang=js&"
export * from "./FileElement.vue?vue&type=script&lang=js&"
import style0 from "./FileElement.vue?vue&type=style&index=0&id=6834498a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6834498a",
  null
  
)

export default component.exports